import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import $ from 'jquery';
import Popper from 'popper.js';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render( < App / > , document.getElementById('root'));